import * as Yup from "yup";

export const equipmentValidationSchema = Yup.object({
    equipmentItem: Yup.string().required("Equipment name is required.")
        .matches(/^(?!\s*$).+/, "Equipment name cannot be empty or just spaces"),

    groupId: Yup.number()
        .required("Equipment group must be selected.")
        .typeError("Please select a valid group."),
    uploadedImage: Yup.mixed()
        .required("Image is required.")
});
